/**
 * GA4 Custom Event Tracking for Crawl Baby Crawl
 * Fires gtag events for all key user actions
 */

const GA_ID = 'G-ZDV98WJ8N9';

const track = (eventName, params = {}) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
};

// Page / Navigation
export const trackPageView = (pagePath, pageTitle) => track('page_view', { page_path: pagePath, page_title: pageTitle });

// CTA / Buttons
export const trackCtaClick = (ctaName, location) => track('cta_click', { cta_name: ctaName, location });
export const trackCityPillClick = (city) => track('city_pill_click', { city });
export const trackNavClick = (linkName) => track('nav_click', { link_name: linkName });

// Crawls
export const trackCrawlView = (crawlId, city, title) => track('crawl_view', { crawl_id: crawlId, city, title });
export const trackCrawlCardClick = (crawlId, city) => track('crawl_card_click', { crawl_id: crawlId, city });
export const trackTicketClick = (crawlId, city, ticketType) => track('ticket_click', { crawl_id: crawlId, city, ticket_type: ticketType });

// Bookings / Checkout
export const trackBeginCheckout = (crawlId, ticketType, quantity, value) => track('begin_checkout', { crawl_id: crawlId, ticket_type: ticketType, quantity, value, currency: 'USD' });
export const trackPurchase = (bookingId, crawlId, value) => track('purchase', { transaction_id: bookingId, crawl_id: crawlId, value, currency: 'USD' });

// Subscribers / Leads
export const trackSubscribe = (method) => track('generate_lead', { method });
export const trackLayloClick = () => track('laylo_click', { location: 'email_banner' });

// Group Bookings
export const trackGroupInquiry = (city, groupSize, eventType) => track('group_inquiry', { city, group_size: groupSize, event_type: eventType });

// Contact
export const trackContactSubmit = (subject) => track('contact_submit', { subject });

// Engagement
export const trackSectionView = (sectionName) => track('section_view', { section_name: sectionName });
export const trackSocialClick = (platform) => track('social_click', { platform });
export const trackBlogRead = (slug, cityTag) => track('blog_read', { slug, city_tag: cityTag });
export const trackGalleryScroll = () => track('gallery_scroll', {});
export const trackFooterSubscribe = () => track('footer_subscribe', {});

export default track;
